const CountBox = ({ count = 0 }) => (
  <div className="custom-index-num h-6 w-6  text-xs flex items-center justify-center rounded-sm text-fontColor">
    {count}
  </div>
);

export default CountBox;
